import React from 'react';
import { type Header } from '@tanstack/react-table';
import classNames from 'classnames';

import { SortIcon } from '../../../../assets';

import styles from './SortButton.module.scss';

export interface ISortButtonProps {
    header: Header<any, unknown>;
}

export const SortButton: React.FC<ISortButtonProps> = ({ header }) => {
    if (header.column.getCanSort() === false) return null;

    const sortDirection = header.column.getIsSorted();

    const handleChangeSortingDirection = () => {
        const next = {
            asc: true,
            desc: undefined,
            false: false,
        };
        const currentSorting = header.column.getIsSorted();
        if (next[currentSorting.toString() as keyof typeof next] === undefined) header.column.clearSorting();
        else header.column.toggleSorting(next[currentSorting.toString() as keyof typeof next]);
    };

    return (
        <button className={classNames(styles.sortButton)} onClick={handleChangeSortingDirection}>
            <SortIcon height={16} width={16} className={styles.sortIcon} data-direction={sortDirection} />
        </button>
    );
};
